import React from "react";

//
import AuthContext from "./auth/Auth";
import CourseContext from "./course/Course";

export default function ContextReducer({ children }) {
  return (
    <>
      <AuthContext>
        <CourseContext>{children}</CourseContext>
      </AuthContext>
    </>
  );
}
